import * as yup from 'yup';
import { t } from 'i18next';

const maxSize = 200 * 1024 * 1024;

const toMb = (val) => {
  return (val / (1024 * 1024)).toFixed(1);
};

/**
 * check that second time after the first one
 * @param {*} data
 * @returns
 */
const checkTimes = (__current, data) => {
  // const createError = data.createError;
  const from = data.parent.timefrom;
  const to = data.parent.timetill;
  if (!from || !to) {
    return true;
  }

  // console.log('🚀 ~ checkTimes ~ from > to:', from > to);
  if (from >= to) {
    return false;
  }

  return true;
};

const checkDates = (__current, data) => {
  const from = data.parent.datefrom;
  const to = data.parent.datetill;
  if (!from || !to) {
    return true;
  }
  if (from > to) {
    return false;
  }

  return true;
};

export const validationSchema = () => {
  // console.log('🚀 ~ msg1:', msg1);
  return yup.object({
    file1: yup
      .mixed()
      //.required('Заполните поле')
      .test('empty', t('validation.Файл не выбран'), (data) => {
        return data && data.file;
      })
      .test('size', t('validation.Превышен максимальный размер файла ') + toMb(maxSize) + 'Mb', (data) => {
        if (!data) {
          return false;
        }

        const { file } = data;
        if (!file) {
          return false;
        }

        if (file.size && file.size > maxSize) {
          //const dif = file.size - maxSize;
          //const err = 'Превышен максимальный размер файла ' + toMb(maxSize) + 'Мб на ' + toMb(dif) + 'Мб';
          return false;
        }

        return true;
      })
      .test('ext', t('validation.Недопустимый тип файла'), (data) => {
        if (!data) {
          return false;
        }
        if (data.file) {
          const type = data.file.type;
          if (!['video/mp4', 'image/png'].includes(type)) {
            return false;
          }
        }
        return true;
      })
      .test('fileerror', t('validation.Ошибка загрузки файла'), (data) => {
        if (!data) {
          return false;
        }
        if (data.info?.error) {
          return false;
        }
        return true;
      })
      .test('wh', t('validation.Недопустимое разрешение файла'), (data) => {
        if (!data) {
          return false;
        }
        const { info } = data; // {duration, width, height}
        if (info) {
          const resolution = window.config.resolution;
          if (info.width > resolution[0] || info.height > resolution[1]) {
            return false;
          }
        }
        return true;
      }),
    duration: yup
      .number()
      //.integer('Только целые числа')
      .positive(t('validation.Только положительные числа'))
      .max(10000, t('validation.Максимум 10000 секунд')),
    //.min(4, 'Минимум 4 символа')
    //.required('Заполните поле')
    datefrom: yup.date().test('dorder-test', t('validation.Дата с не может быть позднее Даты по'), checkDates),
    datetill: yup.date().test('dorder-test', t('validation.Дата по не может быть ранее Даты с'), checkDates),
    timefrom: yup.string().test('order-test', t('validation.Время с не может быть позднее Времени по'), checkTimes),
    timetill: yup.string().test('order-test', t('validation.Время по не может быть ранее Времени с'), checkTimes),
  });
};
